export const LettersListTabIds = Object.freeze({
    CONTACTS_TAB_ID: 1,
    RECENTS_TAB_ID: 0,
});
